import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Product, ProductCat } from 'data/e-commerce/products';
import ProductCard from 'components/common/ProductCard';
import Swiper from 'components/base/Swiper';
import { SwiperSlide } from 'swiper/react';
import { faBolt, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ProductCardCat from 'components/common/ProductCardCat';
import { useAppContext } from 'providers/AppProvider';

const EcomBestSeller = ({ products }: { products: ProductCat[] }) => {
  const {
    config: { theme }
  } = useAppContext();
  return (
    <div
      className={`bg-light rounded-3 p-4 ${theme === 'dark' ? 'bg-dark' : ''}`}
    >
      <div className=" d-flex flex-between-center mb-3">
        <div className="d-flex">
          <FontAwesomeIcon icon={faBolt} className="text-warning fs-6" />
          <h3 className="mb-6 mt-2 fs-5">BESTSELLERS</h3>
          <FontAwesomeIcon icon={faBolt} className="text-warning fs-6" />
        </div>
        {/* <Link
          to="/products-filter"
          className="btn btn-link btn-lg p-0 d-none d-md-block"
        >
          Explore more
          <FontAwesomeIcon icon={faChevronRight} className="fs-9 ms-1" />
        </Link> */}
      </div>
      <Swiper
        slidesPerView={5}
        spaceBetween={16}
        navigationPosition={{ top: '25%' }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1540: {
            slidesPerView: 5,
            spaceBetween: 16
          }
        }}
      >
        {products.map(product => (
          <SwiperSlide key={product._id}>
            <ProductCardCat product={product} setProduct={() => {}} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EcomBestSeller;
